import React, { useState, useEffect } from 'react';
import { message, Empty, Spin, Drawer, Space, Card, Tooltip, Badge } from 'antd';
import moment from 'moment';
import 'moment-timezone';
import { useSelector } from "react-redux";
import PropTypes from 'prop-types';
import FeatherIcon from 'feather-icons-react';
import { Scrollbars } from 'react-custom-scrollbars';
import EmailReportTrack from '../../Reports/EmailReports';
import MailDetailView from '../../Email/MailDetailView';
import { Style, EmailAuthor, EmailHeader } from '../../Email/email-style';
import { EmailByCamaign } from '../../../../Api/Services/EmailApiSevices'
import { FetchAllAttendeeList } from '../../../../Api/Services/CommonApiService'
import { CancelIcon, ClicksEmailIcons, OpenEmailIcons, BouncesEmailIcons, UnSubcripeIcon, ReplyEmailIcons } from '../../../../components/Icons/Icons';

const EmailTable = ({ openEmailTrack, setOpenEmailTrack, UrlId, NacTrigger, setNaCTrigger, profile, emailactiontype }) => {
    const localData = useSelector((state) => state.localRedux);
    const companyProfile = localData.company
    const [allMails, setAllMails] = useState()
    const [emailPopup, setEmailPopup] = useState(false)
    const [popupType, setPopupType] = useState()
    const [emailOpenId, setEmailOpenId] = useState()
    const [allattendeeData, setAllattendeeData] = useState()
    function extractTimeZoneName(tzString) {
        const parts = tzString.split(" ");
        return parts[1];
    }
    function normalizeEmailData1(input) {
        const cleanString = (str) => str.trim().replace(/^["']|["']$/g, "");
        const parseEmail = (emailString) => {
            emailString = cleanString(emailString);
            const match = emailString.match(/(.*)<(.+)>/);
            if (match) {
                return {
                    name: cleanString(match[1]),
                    email: match[2].trim(),
                };
            }
            return {
                name: "",
                email: emailString,
            };
        };
        const normalizeField = (field) => {
            if (!field) return [];
            return field.split(",").map((item) => parseEmail(item.trim()));
        };
        const formattedFrom = parseEmail(input.from || "");
        const formattedTo = normalizeField(input.to || "");
        return {
            ...input,
            subject: input ? input.subject !== "" && input.subject ? input.subject : "(No Subject)" : "(No Subject)",
            from: formattedFrom,
            to: formattedTo,
        };
    }
    const convertTime = (timeStr, timeFormat) => {
        let hours;
        let minutes;
        // let seconds;
        let period;
        if (timeStr.toLowerCase().includes('am') || timeStr.toLowerCase().includes('pm')) {
            // Parse 12-hour time string
            const timeParts = timeStr.match(/(\d{1,2}):(\d{2}):?(\d{2})?/);
            hours = parseInt(timeParts[1], 10);
            minutes = parseInt(timeParts[2], 10);
            // seconds = parseInt(timeParts[3], 10);
            period = timeStr.match(/(am|pm)/i)[0].toLowerCase();

            if (period === 'pm' && hours !== 12) {
                hours += 12;
            } else if (period === 'am' && hours === 12) {
                hours = 0;
            }
        } else {
            // Parse 24-hour time string
            const timeParts = timeStr.split(':');
            hours = parseInt(timeParts[0], 10);
            minutes = parseInt(timeParts[1], 10);
            // seconds = parseInt(timeParts[2], 10);
        }
        if (timeFormat === '12hrs' || timeFormat === '12-hour') {
            period = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12;
            // return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')} ${period}`;
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${period}`;
        }
        // No need for an else here because we return in the if above
        if (timeFormat === '24hrs' || timeFormat === '24-hour') {
            // return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
        }
        throw new Error('Invalid time format specified');
    };
    function convertAndFormatDateTime(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
        const dateFormat = "YYYY-MM-DD";
        const timeFormat = "24hrs";
        const formattedDate = converted.format(dateFormat);
        const rawTime = converted.format("HH:mm");
        const formattedTime = convertTime(rawTime, timeFormat);

        return `${formattedDate} ${formattedTime}`
    }
    const formatDate = (dateString, profile) => {
        const tzString = profile?.timeZone || "(GMT+0:00) UTC";
        const tz = extractTimeZoneName(tzString);
        const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm")
        const today = new Date(currentrealTime);
        const date = new Date(dateString);
        const sameDay =
            date.getDate() === today.getDate() &&
            date.getMonth() === today.getMonth() &&
            date.getFullYear() === today.getFullYear();
        const sameMonth =
            date.getMonth() === today.getMonth() &&
            date.getFullYear() === today.getFullYear();
        if (sameDay) {
            const rawTime = moment(date).format("HH:mm");
            const timeFormat = profile?.timeFormat || "24hrs";
            return convertTime(rawTime, timeFormat);
        }
        if (sameMonth) {
            const weekday = date.toLocaleDateString('en-US', { weekday: 'short' });
            let dateFormat = profile?.dateFormate || "MM-DD-YYYY";
            dateFormat = dateFormat
                .replace(/[-/.,\s]*Y{2,4}/gi, "")
                .replace(/(^[-/.,\s]+|[-/.,\s]+$)/g, "")
            return `${weekday} ${moment(date).format(dateFormat)}`;
        }
        const dateFormat = profile?.dateFormate || 'MM/DD/YYYY';
        return moment(date).format(dateFormat);
    };
    const emailClose = () => {
        setEmailPopup(false)
        setPopupType()
        setEmailOpenId()
        setNaCTrigger("CallBack")
    }
    const ViewDetailPage = (id, type, userId, server) => {
        if (profile?.userId === userId) {
            if (server === emailactiontype?.emailType) {
                setEmailPopup(true)
                setPopupType(type)
                setEmailOpenId(id)
                setNaCTrigger("trigger")
            }
            else {
                message.info("Unable to retrieve the selected email. Please check your email settings or contact the administrator for support")
            }
        }
        else {
            message.info("Email details not found. Please contact your admin for details")
        }
    }
    const getattendeeFrom = (fromEmail, emailName, dataList) => {
        const user = dataList.find(u => u.email === fromEmail);
        const name = user?.name?.trim();
        const validData = name || emailName || fromEmail;
        return validData;
    };
    const getattendeeFrom2 = (fromEmail, emailName, dataList) => {
        const user = dataList.find(u => u.email === fromEmail);
        const name = user?.name?.trim();
        const validData = name || emailName || fromEmail;
        const typeMap = {
            Leads: "Lead",
            Contacts: "Contact",
            User: "User",
            Accounts: "Account"
        };
        const attendee = {
            name: validData || "",
            accountname: user?.accountname || "",
            designation: user?.designation || "",
            type: typeMap[user?.type] || user?.type || "",
            email: user?.email || fromEmail || "",
        };
        return attendee;
    };
    async function AllEmailsByCampaign(id) {
        try {
            const data = await EmailByCamaign(id);
            const FormattedEmailData = await Promise.all(
                data.map(async (item, index) => {
                    let MailData;
                    if (emailactiontype?.emailType === "Google" || emailactiontype?.emailType === "Zoho" || emailactiontype?.emailType === "Outlook" || emailactiontype?.emailType === "Other Email") {
                        MailData = normalizeEmailData1(item);
                    } else {
                        return null;
                    }
                    const enrichedFrom = {
                        ...MailData.from,
                        name:
                            emailactiontype?.email === MailData?.from?.email
                                ? `${profile?.firstName} ${profile?.lastName}`
                                : getattendeeFrom(
                                    MailData?.from?.email,
                                    MailData?.from?.name,
                                    allattendeeData
                                ),
                    };
                    const enrichedTo = Array.isArray(MailData.to) ?
                        MailData.to.map((toItem) => ({
                            ...toItem,
                            ...(emailactiontype?.email === toItem?.email
                                ? { name: `${profile?.firstName} ${profile?.lastName}`, email: toItem?.email, accountname: "", designation: "", type: "User", }
                                : getattendeeFrom2(toItem?.email, toItem?.name, allattendeeData)
                            )
                        })) : MailData.to;
                    const ConvertedDate = MailData.date ? convertAndFormatDateTime(MailData.date, companyProfile, profile) : MailData.date
                    return {
                        no: index + 1,
                        sourceId: MailData.mailId,
                        from: enrichedFrom,
                        to: enrichedTo,
                        date: ConvertedDate,
                        subject: MailData.subject,
                        linkedBy: MailData.userId,
                        mailServer: MailData.mailServer,
                        isSubscription: item.isSubscription,
                        isMailBounce: item.isMailBounce,
                        clickedUrls: item.clickedUrls,
                        openRates: item.openRates,
                        isMailReplyed: item.isMailReplyed
                    };
                })
            );
            const sortedEmails = FormattedEmailData.sort((a, b) => new Date(b.date) - new Date(a.date));
            const CleanedEmailData = sortedEmails.filter(Boolean);
            setAllMails(CleanedEmailData)
        } catch (error) {
            message.error(error);
        }
    }
    async function UserDetailsApi() {
        try {
            const data = await FetchAllAttendeeList()
            setAllattendeeData(data)
        }
        catch (error) {
            setAllattendeeData([])
            message.error(error)
        }
    }
    const handleRefresh = async () => {
        const hideMessage = message.loading("Refreshing analytics...", 0);
        try {
            await Promise.all([
                UserDetailsApi(),
                AllEmailsByCampaign(UrlId[1]),
            ]);
        } catch (error) {
            hideMessage();
        } finally {
            hideMessage();
        }
    };
    const campaignType = UrlId?.[0];
    const campaignId = UrlId?.[1];
    const hasAttendees = allattendeeData?.length > 0;
    useEffect(() => {
        UserDetailsApi()
    }, [openEmailTrack])
    useEffect(() => {
        // if (openEmailTrack && allattendeeData) {
        if (campaignId && hasAttendees) {
            if (campaignType === "?CAMPAIGN") {
                AllEmailsByCampaign(campaignId)
            }
        }
    }, [openEmailTrack, NacTrigger, hasAttendees])
    const closedrawer = () => {
        setOpenEmailTrack(false)
    }
    const onRow = (record) => {
        return {
            onClick: () => {
                ViewDetailPage(record?.sourceId, "Sent", record?.linkedBy, record?.mailServer);
            },
            className: 'clickable-row',
        };
    };
    const columns = [
        {
            title: "Recipients",
            dataIndex: 'name',
            key: 'name',
            width: "20%",
            render: (text, record) => (
                <EmailAuthor className="Email_FontWeightSeen">
                    <div style={{ fontSize: 14 }} className='div-ellipsis' title={record?.to?.map(item => item.email).join(", ") || ""}>
                        {`To: ${(record?.to?.map((item) => (item.name?.trim() ? item.name : item.email)).join(", ") || "")}`}
                    </div>
                </EmailAuthor >
            ),
        },
        {
            title: "Type",
            dataIndex: 'type',
            key: 'type',
            width: "10%",
            render: (text, record) => (
                <EmailHeader className="Email_FontWeightSeen">
                    <p className='tableSubdiv-ellipsis' title={record?.to[0]?.type}><span className='mail-subject'>
                        {record?.to[0]?.type}
                    </span></p>
                </EmailHeader>
            ),
        },
        {
            title: "Subject",
            dataIndex: 'content',
            key: 'content',
            width: "20%",
            render: (text, record) => (
                <EmailHeader className="Email_FontWeightSeen">
                    <p className='tableSubdiv-ellipsis' title={record?.subject && record?.subject !== "" ?
                        record?.subject
                        : "(No Subject)"}><span className='mail-subject'>
                            {record?.subject && record?.subject !== "" ?
                                record?.subject
                                : "(No Subject)"}
                        </span></p>
                </EmailHeader>
            ),
        },
        {
            title: "Designation",
            dataIndex: 'designation',
            key: 'designation',
            width: "20%",
            render: (text, record) => (
                <EmailHeader className="Email_FontWeightSeen">
                    <p className='tableSubdiv-ellipsis' title={record?.to[0]?.designation}><span className='mail-subject'>
                        {record?.to[0]?.designation}
                    </span></p>
                </EmailHeader>
            ),
        },
        {
            title: "Account",
            dataIndex: 'account',
            key: 'account',
            width: "15%",
            render: (text, record) => (
                <EmailHeader className="Email_FontWeightSeen">
                    <p className='tableSubdiv-ellipsis' title={record?.to[0]?.accountname}><span className='mail-subject'>
                        {record?.to[0]?.accountname}
                    </span></p>
                </EmailHeader>
            ),
        },
        {
            title: (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "6px",
                    }}
                >
                    <span>Analytics</span>
                    <FeatherIcon
                        strokeWidth={3}
                        icon="refresh-ccw"
                        size={15}
                        color="#407fe9"
                        style={{ cursor: "pointer", fontWeight: "bold" }}
                        onClick={() => handleRefresh()}
                    />
                </div>
            ),
            dataIndex: 'traking',
            key: 'traking',
            width: "15%",
            render: (text, record) => {
                // Decide colors
                const bounceColor = record.isMailBounce === "Yes" ? "#ff8000" : "gray";
                const subColor = record.isSubscription === "Yes" ? "#ff8000" : "gray";
                const replyColor = record.isMailReplyed === "Yes" ? "#b100ff" : "gray";
                const openColor = record.openRates > 0 ? "#2f8000" : "gray";
                const clickColor =
                    record.clickedUrls && record.clickedUrls.length > 0 ? "#9A3F3F" : "gray";

                return (
                    <EmailHeader className="Email_FontWeightSeen">
                        <span style={{ display: "flex", gap: "12px", justifyContent: "center", marginBottom: "-5px" }}>
                            {/* Bounce */}
                            <Tooltip overlayClassName="ToolTip-Forcast"
                                title={
                                    <div>
                                        <div style={{ textAlign: "center", fontSize: 14, color: "black" }}>
                                            Bounced : {record.isMailBounce || "No"}
                                        </div>
                                    </div>
                                }>
                                <span style={{ color: bounceColor }}>
                                    <BouncesEmailIcons width='16' height='20' />
                                </span>
                            </Tooltip>

                            {/* Opens */}
                            <Tooltip overlayClassName="ToolTip-Forcast" title={
                                <div>
                                    <div style={{ textAlign: "center", fontSize: 14, color: "black" }}>
                                        Opened : {record.openRates || 0} Times
                                    </div>
                                </div>
                            }>
                                <Badge
                                    count={record.openRates > 0 ? record.openRates : 0}
                                    size="small"
                                    offset={[0, 3]}
                                    color='#407fe9' style={{
                                        fontSize: "8px",
                                        height: "12px",
                                        minWidth: "12px",
                                        lineHeight: "12px",
                                    }}
                                >
                                    <span style={{ color: openColor }}>
                                        <OpenEmailIcons width='16' height='20' />
                                    </span>
                                </Badge>
                            </Tooltip>
                            <Tooltip
                                overlayClassName="ToolTip-Forcast"
                                title={() => {
                                    // Count duplicates
                                    const urlCounts = (record.clickedUrls || []).reduce((acc, { url }) => {
                                        acc[url] = (acc[url] || 0) + 1;
                                        return acc;
                                    }, {});

                                    const uniqueUrls = Object.entries(urlCounts);

                                    return (
                                        <div style={{ maxWidth: 250 }}>
                                            <div
                                                style={{
                                                    textAlign: "center",
                                                    fontSize: 14,
                                                    fontWeight: 600,
                                                    color: "black",
                                                    marginBottom: 10,
                                                }}
                                            >
                                                Click Through
                                            </div>

                                            {uniqueUrls.length > 0 ? (
                                                uniqueUrls.map(([url, count]) => (
                                                    <div
                                                        key={url}
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            fontSize: 12,
                                                            color: "#555",
                                                            maxWidth: "100%",
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                display: "inline-block",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap",
                                                                maxWidth: "130px",
                                                            }}
                                                            title={url}
                                                        >
                                                            {url}
                                                        </span>
                                                        <span style={{ marginLeft: 5, flexShrink: 0 }}> : {count} times</span>
                                                    </div>
                                                ))
                                            ) : (
                                                <div style={{ fontSize: 12, color: "#888" }}>No Clicks</div>
                                            )}
                                        </div>
                                    );
                                }}
                            >
                                <Badge
                                    count={record.clickedUrls?.length || 0}
                                    size="small"
                                    offset={[0, 3]}
                                    color='#407fe9' style={{
                                        fontSize: "8px",
                                        height: "12px",
                                        minWidth: "12px",
                                        lineHeight: "12px",
                                    }}
                                >
                                    <span style={{ color: clickColor }}>
                                        <ClicksEmailIcons width='16' height='20' />
                                    </span>
                                </Badge>
                            </Tooltip>

                            <Tooltip overlayClassName="ToolTip-Forcast" title={
                                <div>
                                    <div style={{ textAlign: "center", fontSize: 14, color: "black" }}>
                                        Replied : {record.isMailReplyed || "No"}
                                    </div>
                                </div>
                            }>
                                <span style={{ color: replyColor }}>
                                    <ReplyEmailIcons width='16' height='20' />
                                </span>
                            </Tooltip>
                            {/* Unsubscribe */}
                            <Tooltip overlayClassName="ToolTip-Forcast"
                                title={
                                    <div>
                                        <div style={{ textAlign: "center", fontSize: 14, color: "black" }}>
                                            Unsubscribed : {record.isSubscription || "No"}
                                        </div>
                                    </div>
                                }>
                                <span style={{ color: subColor }}>
                                    <UnSubcripeIcon width='16' height='20' />
                                </span>
                            </Tooltip>
                        </span>
                    </EmailHeader>
                );
            },
        },
        {
            title: "Date",
            dataIndex: 'time',
            key: 'time',
            width: "15%",
            onCell: () => ({
                onClick: (e) => {
                    e.stopPropagation();
                },
            }),
            render: (text, record) => (
                <div style={{ display: "flex", alignItems: "center", justifyContent: 'flex-end', }} className="Email_FontWeightSeen">
                    <span className="email-time">{record?.date && record?.date !== "" ? formatDate(record?.date) : record?.date}</span>
                </div>
            ),
        },
    ];
    // const emailData = [
    //     {
    //         name: "John Doe",
    //         subject: "Subscribed user with some clicks Subscribed Subscribed Subscribed user with some clicks Subscribed user with some clicks",
    //         isSubscription: "No", // No // means not clicked => "Yes"
    //         isMailBounce: "No", // No // isMailBounce=> Yes
    //         date: "2025-09-26 11:50",
    //         clickedUrls: [
    //             { url: "https://www.youtube.com/" },
    //             { url: "https://www.google.com/" },
    //         ],
    //         openRates: 2,
    //     },
    //     {
    //         name: "Jane Smith",
    //         subject: "Unsubscribed user, bounced email",
    //         isSubscription: "No",
    //         isMailBounce: "Yes",
    //         date: "2025-09-25 11:50",
    //         clickedUrls: [], // default
    //         openRates: 0, //  default
    //     },
    //     {
    //         name: "Michael Johnson",
    //         subject: "Active subscriber, no clicks yet",
    //         isSubscription: "Yes",
    //         isMailBounce: "No",
    //         date: "2025-09-25 11:50",
    //         clickedUrls: [],
    //         openRates: 5,
    //     },
    //     {
    //         name: "Emily Davis",
    //         subject: "Inactive subscriber with some clicks",
    //         isSubscription: "Yes",
    //         isMailBounce: "No",
    //         date: "2025-06-25 11:50",
    //         clickedUrls: [
    //             { url: "https://www.youtube.com/" },
    //             { url: "https://www.twitter.com/" },
    //         ],
    //         openRates: 1,
    //     },
    // ];
    return (
        <>
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                closable={false}
                placement="right"
                title="Email Analytics Report"
                open={openEmailTrack}
                width="80%"
                extra={
                    < Space >
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => { closedrawer(false) }}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    closedrawer(false)
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space >
                }
                footer={false}
            >
                <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                    <div style={{ margin: "20px 40px" }}>
                        <EmailReportTrack EmailData={allMails} />
                        {allMails ?
                            (allMails?.length > 0 ?
                                <>
                                    <div style={{ marginTop: 10 }}>
                                        <Card className="DetailsTabCard">
                                            < Style
                                                className="table-responsive tableStyle"
                                                rowClassName='seen-row'
                                                columns={columns}
                                                dataSource={allMails}
                                                // scroll={{ y: 793 }}
                                                pagination={false}
                                                onRow={onRow}
                                                tableLayout="fixed"
                                            />
                                        </Card>
                                    </div>
                                </>
                                :
                                <div style={{ padding: "10%" }}>
                                    <Empty />
                                </div>)
                            :
                            <div className="spin">
                                <Spin />
                            </div>}
                    </div></Scrollbars>
            </Drawer >
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                closable={false}
                placement="right"
                title="Email Message"
                open={emailPopup}
                extra={
                    < Space >
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => emailClose()}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    emailClose()
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space >
                }
                width={1000}>
                <MailDetailView detailsId={emailOpenId} detailsPage={popupType} Comefrom="Entity" blukGroupid="bulk" setNaCTrigger={setNaCTrigger} />
            </Drawer>
        </>
    );
}
EmailTable.propTypes = {
    UrlId: PropTypes.array.isRequired,
    NacTrigger: PropTypes.string.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
    profile: PropTypes.object.isRequired,
    emailactiontype: PropTypes.object.isRequired,
    openEmailTrack: PropTypes.bool.isRequired,
    setOpenEmailTrack: PropTypes.func.isRequired,
};
export default EmailTable;